import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/payment-edit-screen.module.scss';
import Loader from 'src/components/Loader';

import Form, { PaymentFormData } from '../../components/PaymentForm';
import { IPayment } from 'src/types/payment';
import RoleLayout from '../../../../../../components/layout/RoleLayout';
import { Paginated } from '../../../../../../services/api-handlers/pagination';

import { IServiceType } from '../../../../../../types/service-types';
import { IInvoice } from '../../../../../../types/invoice';
import { QueryParams } from '../../../../../../types/grid';
import { toast } from 'react-toastify';
import CaseEnum from '../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    payment: IPayment | null;
    inProgress: boolean;
    students: SelectObject[];
    vendors: SelectObject[];
    providers: SelectObject[];
    districts: SelectObject[];
    serviceTypes: Paginated<IServiceType>;
    invoices: Paginated<IInvoice>;
    valuesForm: Partial<PaymentFormData>;
    caseNumbers: { [key: string]: string | null }[];
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getStudents: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getInvoices: (params: QueryParams) => void;
    changeValue: (field: string, value: string | null) => void;
    getCaseNumbers: () => void;
}

interface RouteParams {
    id: string;
}
export interface OwnProps extends RouteComponentProps<RouteParams> {
    history: any;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const PaymentEditScreen: FC<Props> = (props: Props) => {
    const {
        payment,
        match: {
            params: { id },
        },
        getStudents,
        getDistricts,
        getProviders,
        getVendors,
        getServiceTypes,
        invoices,
        changeValue,
        getInvoices,
        students,
        providers,
        vendors,
        districts,
        serviceTypes,
        valuesForm,
        getCaseNumbers,
        caseNumbers,
        getData,
        inProgress,
    } = props;
    const [stateInvoice, setStateInvoice] = useState<any>({
        list: [],
        page: 1,
        invoiceIds: [],
        isFilterOn: false,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    });
    useEffect(() => {
        if (typeof invoices.totalPages === 'number' && payment && `${payment?.id}` === id) {
            if (stateInvoice.withIds && !inProgress) {
                if (stateInvoice.invoiceIds.length) {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.invoiceIds);

                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];
                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        list: uniq,
                        inProgress: false,
                        withIds: true,
                        isFilterOn: true,
                    });
                } else {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.list);

                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];

                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        invoiceIds: invoices.list,
                        list: uniq,
                        inProgress: false,
                        withIds: true,
                    });
                }
            } else {
                const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.list);
                const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                const uniq: ListType<IInvoice> = [...some];

                setStateInvoice({
                    ...stateInvoice,
                    ...invoices,
                    list: uniq,

                    inProgress: false,
                    withIds: true,
                });
            }

            if (!inProgress && !stateInvoice.withIds && payment?.paymentInvoices.length) {
                const invs: any = [];

                payment.paymentInvoices.forEach((it: any) => {
                    invs.push(it?.invoice?.id);
                });
                getInvoices({
                    page: 1,
                    itemsPerPage: 9000,
                    filters: {
                        id: invs,
                    },
                });
            }
        }

        // eslint-disable-next-line
    }, [inProgress, invoices]);
    useEffect(() => {
        if (!payment || payment.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (payment && `${payment?.id}` === id) {
            getStudents({
                page: 1,
                itemsPerPage: 9000,
            });
            getProviders({
                page: 1,
                itemsPerPage: 9000,
            });
            /*const objFilter: any = { 'occasion.caseType': payment.caseType };
            if (+payment.caseType === 1) {
                objFilter.status = [5, 6, 9];
            }
            getInvoices({
                page: 1,
                itemsPerPage: 9000,
                filters: objFilter,
            });*/
            getCaseNumbers();
            getDistricts({
                page: 1,
                itemsPerPage: 9000,
            });
            getVendors({
                page: 1,
                itemsPerPage: 9000,
            });
            getServiceTypes({
                page: 1,
                itemsPerPage: 9000,
            });
        }

        // eslint-disable-next-line
    }, [payment?.id, getVendors, getServiceTypes, getDistricts, getStudents]);

    let amount: any = 0;
    let paymentCredits: any = [];
    if (valuesForm) {
        amount = valuesForm.amount ? valuesForm.amount : 0;
        paymentCredits = valuesForm.paymentCredits ? valuesForm.paymentCredits : [];
    }

    let stateAmount = 0;
    let amountCredits = 0;

    const [stateData, setStateData] = useState<any>({});
    Object.keys(stateData).forEach((k: string) => {
        stateAmount += stateData[k].remainingAmount ? +stateData[k].remainingAmount : 0;
    });
    paymentCredits.forEach((it: any) => {
        if (+it.status !== 2) {
            amountCredits += it.amount ? +it.amount : 0;
        }
    });

    useEffect(() => {
        const dataStateInit: any = {};

        if (payment && `${payment?.id}` === id) {
            invoices.list.forEach((it: IInvoice) => {
                it.paymentInvoices.forEach((itP: any) => {
                    if (+itP.payment.id === +payment.id && !itP.paymentCredit) {
                        dataStateInit[+it.id] = { action: true, remainingAmount: itP.amount };
                    }
                });
            });
        }

        if (Object.values(dataStateInit).length) {
            setStateData(dataStateInit);
        }
        // eslint-disable-next-line
    }, [invoices, payment]);

    const totalAmount: number = +amountCredits + +stateAmount;
    const remainAmount: number = +(+amount - +totalAmount).toFixed(2);

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (!Object.values(stateData).length) {
            toast.error('no applied Invoices!');
            return false;
        }
        if (+remainAmount === 0) {
            handleSubmit(e);
        } else {
            toast.error('Remaining amount needs to be 0!');
            return false;
        }
    };

    const handleDraftSub = (handleSubmit: (e: any) => void, e: any) => {
        handleSubmit(e);
    };
    const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(typeEnum);
    const valueCaseType = caseTypes.find((it) => it.value === payment?.caseType);
    const caseTypeObj = valueCaseType ? valueCaseType : {};

    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'PAYMENTS', path: routes.PAYMENTS_LIST },
                    { name: `EDIT PAYMENT`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {!payment ? (
                    <Loader />
                ) : (
                    <Form
                        students={students}
                        handleSub={handleSub}
                        handleDraftSub={handleDraftSub}
                        isDraft={payment?.status === 4}
                        vendors={vendors}
                        invoices={{ ...stateInvoice, inProgress: invoices.inProgress }}
                        amountValue={amount}
                        districts={districts}
                        getData={getInvoices}
                        providers={providers}
                        stateData={stateData}
                        caseNumbers={caseNumbers}
                        changeValue={changeValue}
                        setStateData={setStateData}
                        serviceTypes={serviceTypes}
                        paymentCredits={payment?.paymentCredits}
                        initialValues={{ ...payment, caseType: valueCaseType }}
                        caseTypeHistory={caseTypeObj}
                        remainAmount={remainAmount}
                        totalAmount={totalAmount}
                    />
                )}
            </div>
        </RoleLayout>
    );
};
export default PaymentEditScreen;
